import { AfterViewInit, Component, HostListener, Inject,
         OnDestroy, ChangeDetectorRef
       } from '@angular/core';

import { BoundingBox, ImagePlaceholder
       } from 'collage-designer/stage/placeholder/image-placeholder';
import { PlaceholderService
       } from 'collage-designer/stage/placeholder/placeholder.service';
import { Utils } from 'core/utils';
import { Subscription } from 'rxjs';
import { ToolboxComponent } from '../toolbox.component';
import { ToolboxService } from '../toolbox.service';

@Component({
    selector: 'image-toolbox',
    templateUrl: './image-toolbox.component.html',
    styleUrls: ['../toolbox.component.scss', './image-toolbox.component.scss',],
    standalone: false
})
export class ImageToolboxComponent extends ToolboxComponent
    implements OnDestroy, AfterViewInit
{
  public placeholder: ImagePlaceholder;

  protected name: string = 'ImageToolbox';

  private subscriptions: Subscription = new Subscription();
  private originalCrop: BoundingBox = undefined;
  private originalMatrix: DOMMatrixReadOnly = undefined;

  constructor(
      private cdr: ChangeDetectorRef,
      @Inject(ToolboxService) toolboxService,
      @Inject(PlaceholderService) private placeholderService:
          PlaceholderService)
  {
    super(toolboxService);
  }

  public ngAfterViewInit(): void
  {
    this.subscriptions.add(
        this.placeholderService.focusedPlaceholderChanged.subscribe(p => {
          if (p instanceof ImagePlaceholder) {
            this.initialize();
          }
        }));
    this.subscriptions.add(
        this.toolboxService.targetChanged.subscribe(_ => {
            this.initialize();
        }));
  }

  public ngOnDestroy(): void
  {
    this.subscriptions.unsubscribe();
  }

  private initialize(): void
  {
    const pl = this.placeholderService.getFocusedPlaceholder();
    const dimensions =
        pl instanceof ImagePlaceholder ? pl.getDimensions() : undefined;

    if (dimensions === undefined ||
        this.toolboxService.getActiveToolboxName('design-step') !== this.name) {
      this.placeholder = undefined;
      return;
    }

    this.placeholder = pl as unknown as ImagePlaceholder;
    this.originalCrop = this.placeholder.getBoundingBox();
    this.originalMatrix = this.placeholder.transformationManager.getMatrix();

    this.cdr.detectChanges();
  }

  public btnOKClick(): void
  {
    super.btnCloseClick();
  }

  protected respondToCloseRequest(): void
  {
    this.btnCancelClick();
  }

  public btnCancelClick(): void
  {
    if (this.placeholder !== undefined) {
      this.placeholder.applyBoundingBox(this.originalCrop, this.originalMatrix);
    }

    super.btnCloseClick();
  }

  @HostListener('window:resize') public onResize(ev): void
  {
    if (Utils.isLargeDevice()) {
      this.btnCancelClick();
    }
  }
}
